<template>
  <v-container>
    <v-row no-gutters v-if="onlyCourse" class="d-flex">
      <template>
        <v-col cols="6" v-if="showPublishDate">
          <v-card
            class="d-flex justify-end label-text text-truncate"
            :style="textSize"
            flat
          >
            Date Published:
          </v-card>
        </v-col>
        <v-col cols="6" v-if="showPublishDate">
          <v-card
            class="d-flex justify-start flex-nowrap ml-2 label-text"
            :style="textSize"
            flat
          >
            {{ course.publishedDate }}
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-end  label-text text-truncate"
            :style="textSize"
            flat
          >
            Participants:
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-start  ml-2 label-text"
            :style="textSize"
            flat
          >
            {{ course.participants }}
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-end label-text text-truncate"
            :style="textSize"
            flat
          >
            Avg Time:
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-start flex-nowrap ml-2 label-text"
            :style="textSize"
            flat
          >
            {{ formatDuration(course.avgTimeSpent) }}
          </v-card>
        </v-col>
        <v-col cols="6" v-if="showAvgInteractions">
          <v-card
            class="d-flex justify-end label-text text-truncate"
            :style="textSize"
            flat
          >
            Avg Interactions:
          </v-card>
        </v-col>
        <v-col cols="6" v-if="showAvgInteractions">
          <v-card
            class="d-flex justify-start flex-nowrap ml-2 label-text"
            :style="textSize"
            flat
          >
            {{ course.avgInteractions }}
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-end label-text text-truncate"
            :style="textSize"
            flat
          >
            Launches:
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-start flex-nowrap ml-2 label-text"
            :style="textSize"
            flat
          >
            {{ course.launches }}
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-end label-text text-truncate"
            :style="textSize"
            flat
          >
            Pass:
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-start flex-nowrap ml-2 label-text"
            :style="textSize"
            flat
          >
            {{ course.pass }}
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-end label-text text-truncate"
            :style="textSize"
            flat
          >
            Fail:
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-start flex-nowrap ml-2 label-text"
            :style="textSize"
            flat
          >
            {{ course.fail }}
          </v-card>
        </v-col>
      </template>
    </v-row>
    <v-row no-gutters v-else class="d-flex">
      <template>
        <v-col cols="6">
          <v-card
            class="d-flex justify-end label-text text-truncate"
            :style="textSize"
            flat
          >
            Status:
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-start flex-nowrap ml-2 label-text"
            :style="textSize"
            flat
          >
            {{ status }}
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-end label-text text-truncate"
            :style="textSize"
            flat
          >
            Time Spent:
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-start flex-nowrap ml-2 label-text"
            :style="textSize"
            flat
          >
            {{ formatDuration(timeSpent) }}
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-end label-text text-truncate"
            :style="textSize"
            flat
          >
            Attempts:
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-start flex-nowrap ml-2 label-text"
            :style="textSize"
            flat
          >
            {{ attempts }}
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-end label-text text-truncate"
            :style="textSize"
            flat
          >
            Interactions:
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-start flex-nowrap ml-2 label-text"
            :style="textSize"
            flat
          >
            {{ interactions }}
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-end label-text text-truncate"
            :style="textSize"
            flat
          >
            Last Interaction:
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card
            class="d-flex justify-start flex-nowrap ml-2 label-text"
            :style="textSize"
            flat
          >
            {{ lastInteraction }}
          </v-card>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import { getDuration, capitalizeFirstLetter } from '../Constants'
import moment from 'moment'

export default {
  props: {
    course: {
      type: Object,
      required: true
    },
    showPublishDate: {
      type: Boolean,
      default: false,
      required: false
    },
    showAvgInteractions: {
      type: Boolean,
      default: true,
      required: false
    },
    agent: {
      type: String,
      default: null,
      required: false
    }
  },
  data() {
    return {
      status: null,
      timeSpent: null,
      attempts: null,
      interactions: null,
      lastInteraction: null
    }
  },
  computed: {
    onlyCourse() {
      return this.agent == null
    },
    textSize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'font-size: 0.5rem;'
          break
        case 'md':
          return 'font-size: 0.63rem;'
          break
        case 'lg':
          return 'font-size: 0.77rem;'
          break
        case 'xl':
          return 'font-size: 0.87rem;'
          break
        default:
          return 'font-size: 0.87rem;'
      }
    }
  },
  methods: {
    formatDuration(date) {
      return getDuration(date)
    }
  },
  mounted() {
    if (this.agent != null) {
      let a = parseInt(this.agent)
      let interactionsCopy = Object.assign([], this.course.interactions)
      interactionsCopy = _.filter(interactionsCopy, function(o) {
        if (o.userId != null && o.userId !== undefined) {
          return o.userId === a
        }
      })

      this.interactions = 0
      this.attempts = 0
      this.timeSpent = null
      this.status = null
      this.lastInteraction = null

      interactionsCopy.forEach(element => {
        this.interactions++

        if (element.verb === 'failed' || element.verb === 'passed') {
          this.status = element.verb
        }

        if (element.verb === 'attempted') {
          this.attempts++
        }

        if (this.lastInteraction == null) {
          this.lastInteraction = moment(element.timestamp)
        } else {
          if (moment(element.timestamp).isAfter(this.lastInteraction)) {
            this.lastInteraction = moment(element.timestamp)
          }
        }

        if (element.duration) {
          if (this.timeSpent) {
            this.timeSpent = moment
              .duration(element.duration)
              .add(this.timeSpent)
          } else {
            this.timeSpent = moment.duration(element.duration)
          }
        }
      })
      this.lastInteraction = moment(this.lastInteraction).format('MM/DD/YYYY')
      if (this.status != null) {
        this.status = capitalizeFirstLetter(this.status)
      }
    }
  }
}
</script>

<style>
.label-text {
  color: rgba(0, 0, 0, 0.54);
  font-size: 0.87rem;
  line-height: 22px;
}
</style>
